import { render } from "./UsersDrawer.vue?vue&type=template&id=273f7b17&scoped=true"
import script from "./UsersDrawer.vue?vue&type=script&lang=js"
export * from "./UsersDrawer.vue?vue&type=script&lang=js"

import "./UsersDrawer.vue?vue&type=style&index=0&id=273f7b17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273f7b17"]])

export default __exports__